import { ThemeEvents } from '@theme/events';

const SELECTOR = '[data-free-shipping-progress]';
const MESSAGE_SELECTOR = '.free-shipping-progress__message span:last-child';
const FILL_SELECTOR = '[data-free-shipping-progress-fill]';

let cartRequest;

function formatMoney(cents, moneyFormat) {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, moneyFormat);
  }

  return `$${Math.round(cents / 100)}`;
}

function updateProgress(element, cartTotal) {
  const threshold = Number(element.dataset.thresholdCents || 0);
  if (!threshold) return;

  const remaining = threshold - cartTotal;
  const progress = Math.min(100, Math.max(0, (cartTotal / threshold) * 100));
  const reached = remaining <= 0;
  const moneyFormat = element.dataset.moneyFormat || '${{amount}}';
  const remainingText = element.dataset.remainingText || 'Agrega [amount] mas para obtener envio gratuito';
  const successText = element.dataset.successText || 'Felicidades, ya tienes envio gratuito';
  const amount = formatMoney(Math.max(remaining, 0), moneyFormat).replace(/\\.00\\b/, '');
  const message = reached ? successText : remainingText.replace('[amount]', amount);

  element.classList.toggle('free-shipping-progress--success', reached);
  element.querySelector(FILL_SELECTOR)?.style.setProperty('--free-shipping-progress', `${progress}%`);

  const messageElement = element.querySelector(MESSAGE_SELECTOR);
  if (messageElement) messageElement.textContent = message;

  const bar = element.querySelector('[role="progressbar"]');
  bar?.setAttribute('aria-label', message);
  bar?.setAttribute('aria-valuenow', String(Math.min(cartTotal, threshold)));
}

function updateAll(cartTotal) {
  document.querySelectorAll(SELECTOR).forEach((element) => {
    if (element instanceof HTMLElement) updateProgress(element, cartTotal);
  });
}

async function fetchCart() {
  if (!cartRequest) {
    cartRequest = fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load cart state');
        return response.json();
      })
      .finally(() => {
        cartRequest = null;
      });
  }

  return cartRequest;
}

async function getCartTotalFromEvent(event) {
  const detail = event?.detail;

  if (detail?.resource?.total_price != null) {
    return Number(detail.resource.total_price);
  }

  const cart = await fetchCart();
  return Number(cart?.total_price ?? 0);
}

function handleCartUpdate(event) {
  getCartTotalFromEvent(event)
    .then((cartTotal) => {
      if (cartTotal != null && Number.isFinite(cartTotal)) updateAll(cartTotal);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[free-shipping-progress] Cart update failed:', error);
    });
}

document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
document.addEventListener('shopify:section:load', handleCartUpdate);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => handleCartUpdate(new Event('DOMContentLoaded')), { once: true });
} else {
  handleCartUpdate(new Event('load'));
}
